// extracted by mini-css-extract-plugin
module.exports = {"container":"skudetails_container__KD6xe","description":"skudetails_description__vXq27","fadein":"skudetails_fadein__Z_UDs","loading":"skudetails_loading__Z66dG"};